// from node_modules
import 'togglr'

// internal
import './main/no-js'
import './main/user-is-tabbing'
//import './main/sentry'
import './main/tabs'
import './main/navbar'
import './main/language-currency'
import './main/swiper'
import './main/lightbox'
import './main/search'
import './main/filters'
//import './main/filter-slider'
import './main/quantity-calc'
import './main/cart'
import './main/add-to-wishlist'
import './main/newsletter'
import './main/recaptcha'

import appPackage from '../../../package.json'
const {
	name,
	version
} = appPackage

console.log(`${name} v${version} is up and running! 🚀`)
